<template>
  <div class="flex items-center">
    <img
      style="width: 25px; height: 25px; object-fit: cover;" 
      class="person-img rounded-full shadow-md block" 
      :src="params.data.picture || 'http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png'" 
    />
     {{ params.data.full_name }}
  </div>
</template>

<script>
export default {
  name: 'TeacherStudentDetailsNameCell'
}
</script>